import { __decorate } from "tslib";
import { AsnProp } from "@peculiar/asn1-schema";
import { Signature } from "./signature";
import { TBSRequest } from "./tbs_request";
export class OCSPRequest {
    constructor(params = {}) {
        this.tbsRequest = new TBSRequest();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: TBSRequest, raw: true })
], OCSPRequest.prototype, "tbsRequest", void 0);
__decorate([
    AsnProp({ type: Signature, optional: true, context: 0 })
], OCSPRequest.prototype, "optionalSignature", void 0);
